// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'

import $ from 'jquery'
window.jQuery = $
window.$ = $

import vueSeamlessScroll from 'vue-seamless-scroll'
import 'element-ui/lib/theme-chalk/index.css'

import animated from 'animate.css'
import router from './router'
// import VideoPlayer from 'vue-video-player'
import './css/common.css'

import store from './store/index'
import i18n from './i18n/index'
import locale from 'element-ui/lib/locale/lang/en'
// import VueMarquee from 'vue-marquee-component'
// import VueMarqueeBar from "vue-marquee-bar"
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: "Mez2e25fENQy1yseDrPrdPxU"
})
// Vue.use(VueMarquee)
// Vue.use(VueMarqueeBar)
Vue.use(animated)

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import {compressImage, compressImg} from './utils/util';
Vue.prototype.$compressImage = compressImage //注册为全局变量,this.$compressImg()//调用
Vue.prototype.$compressImg = compressImg //注册为全局变量,this.$compressImg()//调用

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  error: '.asstes/noImg.png',
  loading: './assets/noImg.png'
})

// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
import DynamicMarquee from 'vue-dynamic-marquee';
Vue.component('dynamic-marquee', DynamicMarquee);

Vue.use(ElementUI, { locale })

Vue.use(animated)
Vue.use(vueSeamlessScroll)

// Vue.use(VideoPlayer)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js